import React, { useEffect, useRef } from 'react';
import './CreationWizard.css';

export default function CreationWizard({ title, steps, step, onStep, onClose, onSubmit, busy, submitLabel, description, headingAside, children, error }) {
  const heading = useRef(null);
  const content = useRef(null);
  useEffect(() => {
    heading.current?.focus();
    if (content.current) content.current.scrollTop = 0;
  }, [step]);
  return <div className="modal-overlay-preencher cw-overlay">
    <section className="cw-dialog" role="dialog" aria-modal="true" aria-label={title}>
      <header className="cw-header"><div><span>VETIM</span><h2>{title}</h2></div><button type="button" onClick={onClose} disabled={busy} aria-label="Fechar">×</button></header>
      <nav className="cw-steps" aria-label="Etapas do cadastro">{steps.map((label, index) => <button type="button" key={label} disabled={busy || index > step} aria-current={index === step ? 'step' : undefined} onClick={() => onStep(index)}><span>{index < step ? '✓' : index + 1}</span>{label}</button>)}</nav>
      <form noValidate onSubmit={onSubmit}>
        <div className="cw-content" ref={content}><div className="cw-inner">
          <div className="cw-heading cw-heading-row"><div><small>ETAPA {step + 1} DE {steps.length}</small><h3 ref={heading} tabIndex={-1}>{steps[step]}</h3>{description && <p>{description}</p>}</div>{headingAside && <fieldset disabled={busy} className="cw-heading-aside">{headingAside}</fieldset>}</div>
          {error && <div className="cw-error" role="alert">{error}</div>}
          <fieldset disabled={busy} className="cw-fields">{children}</fieldset>
        </div></div>
        <footer className="cw-footer"><button type="button" className="cw-secondary" disabled={busy} onClick={step ? () => onStep(step - 1) : onClose}>{step ? 'Voltar' : 'Cancelar'}</button><span>{step + 1} / {steps.length}</span><button type="submit" className="cw-primary" disabled={busy}>{busy ? 'Salvando...' : step === steps.length - 1 ? submitLabel : 'Continuar →'}</button></footer>
      </form>
    </section>
  </div>;
}

export function ReviewCard({ title, onEdit, rows }) {
  return <section className="cw-review"><header><h4>{title}</h4><button type="button" onClick={onEdit}>Editar</button></header><dl>{rows.map(([label, value]) => <div key={label}><dt>{label}</dt><dd>{value || 'Não informado'}</dd></div>)}</dl></section>;
}
